import { Badge } from "react-bootstrap";

export default function ApprovalBadge(props) {
  return <Badge {...props}>{props.text}</Badge>;
}
